export const query_cerved_searchEntities = `
query cervedSearchEntities($tenantId: String!, $aziendaId: Int!, $searchText: String, $entityType: String, $excludeCeased: Boolean) {
    cervedSearchEntities(tenantId: $tenantId, aziendaId: $aziendaId, searchText: $searchText, entityType: $entityType, excludeCeased: $excludeCeased) {
        items {
            idSoggetto
            denominazione
            nome
            cognome
            codiceFiscale
            partitaIva
            naturaGiuridica
            statoAttivita
            isPerson
            indirizzo
            comune
            provincia
        }
        totalCount
        truncated
    }
}`;

export const query_cerved_entityProfile = `
query cervedEntityProfile($tenantId: String!, $aziendaId: Int!, $idSoggetto: String!) {
    cervedEntityProfile(tenantId: $tenantId, aziendaId: $aziendaId, idSoggetto: $idSoggetto) {
        idSoggetto
        denominazione
        nome
        cognome
        codiceFiscale
        partitaIva
        isPerson
        naturaGiuridica
        codiceAteco
        descrizioneAteco
        dataCostituzione
        statoAttivita
        dataNascita
        comuneNascita
        numeroRea
        indirizzo
        comune
        provincia
        cap
        paese
    }
}`;

export const query_cerved_entityContacts = `
query cervedEntityContacts($tenantId: String!, $aziendaId: Int!, $idSoggetto: String!) {
    cervedEntityContacts(tenantId: $tenantId, aziendaId: $aziendaId, idSoggetto: $idSoggetto) {
        tipo
        valore
    }
}`;

export const query_cerved_entityConnections = `
query cervedEntityConnections($tenantId: String!, $aziendaId: Int!, $idSoggetto: String!, $includeTerminated: Boolean) {
    cervedEntityConnections(tenantId: $tenantId, aziendaId: $aziendaId, idSoggetto: $idSoggetto, includeTerminated: $includeTerminated) {
        idSoggetto
        denominazione
        nome
        cognome
        codiceFiscale
        isPerson
        tipoSoggetto
        carica
        isRappresentanteLegale
        dataNomina
        dataRiconferma
        dataCessazione
        isCessata
    }
}`;

export const query_cerved_entityBeneficialOwners = `
query cervedEntityBeneficialOwners($tenantId: String!, $aziendaId: Int!, $idSoggetto: String!, $shareValue: Int) {
    cervedEntityBeneficialOwners(tenantId: $tenantId, aziendaId: $aziendaId, idSoggetto: $idSoggetto, shareValue: $shareValue) {
        idSoggetto
        denominazione
        nome
        cognome
        codiceFiscale
        dataNascita
        comuneNascita
        isPerson
        tipoSoggetto
        percentualeQuota
        livello
        tipoTitolarita
        catenaPartecipativa {
            idSoggetto
            denominazione
            nome
            cognome
            codiceFiscale
            isPerson
            tipoSoggetto
        }
    }
}`;
